<div class="container">
    <!-- Header Section -->
    <div class="header-section">
      <h2>Notification Profiles</h2>
      <button class="add-profile-button" (click)="openProfileModal()">
        <span>+</span> Add Profile
      </button>
    </div>
    
    <div class="profiles-container">
      <!-- Empty State -->
      <div *ngIf="profiles.length === 0" class="empty-state">
        <div class="empty-state-icon">📬</div>
        <p class="empty-state-text">No notification profiles created yet.</p>
        <button class="mab__button mab__button--primary" (click)="openProfileModal()">
          Create Your First Profile
        </button>
      </div>
    
      <!-- Profile List -->
      <div *ngFor="let profile of profiles; let i = index" 
           class="profile-item fade-in" 
           [ngClass]="{'primary': profile.isPrimary}">
        
        <div class="profile-header">
          <!-- Primary Toggle -->
          <div class="profile-primary">
            <label class="switch">
              <input type="checkbox" 
                     [checked]="profile.isPrimary" 
                     [disabled]="profile.isPrimary"
                     (change)="setPrimary(profile)">
              <span class="slider"></span>
            </label>
            <span class="primary-label">Primary</span>
          </div>
          
          <!-- Profile Name -->
          <h4 class="profile-name">{{ profile.name || 'Unnamed Profile' }}</h4>
          
          <!-- Actions -->
          <div class="profile-actions">
            <button class="mab__button mab__button--secondary" (click)="editProfile(i)">
              Edit
            </button>
            <button class="mab__button mab__button--danger" (click)="deleteProfile(i)" [disabled]="isLoading">
              <span *ngIf="isLoading">Deleting...</span>
              <span *ngIf="!isLoading">Delete</span>
            </button>
          </div>
        </div>
        
        <!-- Profile Content -->
        <div class="profile-content">
          <!-- Email Type Content -->
          <div *ngIf="profile.type === 'email'">
            <div class="info-row">
              <span class="info-label">Template:</span>
              <span class="info-value">{{ getTemplateLabel(profile.template) }}</span>
            </div>
            <ul class="email-list">
              <li *ngFor="let email of profile.emails" class="email-item">
                <span class="email-text">{{ email }}</span>
              </li>
            </ul>
            <div *ngIf="!profile.emails || profile.emails.length === 0" class="empty-state-text">
              No emails added
            </div>
          </div>
          
          <!-- Slack Type Content -->
          <div *ngIf="profile.type === 'slack'">
            <div class="info-row">
              <span class="info-label">Workspace:</span>
              <span class="info-value">{{ profile.workspaceName || getWorkspaceName(profile.workspace) }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">Channels:</span>
              <div class="info-value">
                <div class="channel-tags">
                  <span class="channel-tag" *ngFor="let channel of profile.channels">
                    #{{ channel }}
                  </span>
                </div>
                <div *ngIf="!profile.channels || profile.channels.length === 0" class="empty-state-text">
                  No channels selected
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- Modal for Adding/Editing Profile -->
    <div *ngIf="modalVisible" class="modal-backdrop">
      <div class="modal fade-in">
        <div class="modal-header">
          <h3 class="modal-title">{{ currentProfileIndex !== null ? 'Edit Profile' : 'Create New Profile' }}</h3>
          <button class="close-modal" (click)="closeModal()">×</button>
        </div>

        <div class="modal-body">
        <!-- Profile Form -->
        <div class="form-group">
          <label class="form-label">Profile Name</label>
          <input class="form-control" [(ngModel)]="profileForm.name" placeholder="Enter profile name" [disabled]="currentProfileIndex !== null" [ngClass]="{'input-error': nameError}" />
        </div>
        
        <div class="form-group">
          <label class="form-label">Notification Type</label>
          <select class="form-control" [(ngModel)]="profileForm.type" (change)="onTypeChange()">
            <option value="email">Email Notification</option>
            <option value="slack" [nonProjectFeatureNavState]="'SLACK_INTEGRATION'">Slack Notification</option>
          </select>
        </div>
        
        <div class="form-group">
          <label class="switch">
            <input type="checkbox" [(ngModel)]="profileForm.isPrimary">
            <span class="slider"></span>
          </label>
          <span class="primary-label">Set as primary profile</span>
        </div>
        
        <!-- Email Configuration -->
        <div *ngIf="profileForm.type === 'email'" class="form-section">
          <h4>Email Addresses</h4>
          
          <div class="email-list">
            <div *ngFor="let email of profileForm.emails; let i = index" class="email-item">
              <span class="email-text">{{ email }}</span>
              <button class="mab__button mab__button--danger" (click)="removeEmail(i)">×</button>
            </div>
          </div>
          
          <div class="email-input-group">
            <input class="form-control" type="email" [(ngModel)]="newEmail" placeholder="Enter email address" />
            <button class="mab__button mab__button--secondary" (click)="addEmailToForm()">Add</button>
          </div>

          <div class="form-group">
            <label class="form-label">Email Template</label>
            <select class="form-control" [(ngModel)]="profileForm.template">
              <option *ngFor="let opt of emailTemplateOptions" [value]="opt.id">{{ opt.label }}</option>
            </select>
            <iframe class="template-preview-frame" [srcdoc]="previewHtmlFor(profileForm.template)" [style.height.px]="templatePreviewHeight" (load)="onTemplatePreviewLoad($event)" title="Email template preview" sandbox="allow-same-origin" scrolling="no"></iframe>
          </div>
        </div>
        
        <!-- Slack Configuration -->
        <div *ngIf="profileForm.type === 'slack'" class="form-section">
          <div class="form-group">
            <label class="form-label">Workspace</label>
            <div *ngIf="isLoading" class="loading-indicator">Loading workspaces...</div>
            <select class="form-control" [(ngModel)]="profileForm.workspace" (change)="fetchChannels(profileForm.workspace)" [disabled]="isLoading">
              <option value="">Select a workspace</option>
              <option *ngFor="let workspace of workspaces" [value]="workspace.id || workspace.name">{{ workspace.name || workspace }}</option>
            </select>
          </div>
          
          <div class="form-group" *ngIf="profileForm.workspace">
            <label class="form-label">Channels (select multiple)</label>
            <div *ngIf="isLoading" class="loading-indicator">Loading channels...</div>
            
            <div class="channel-selection" *ngIf="!isLoading">
              <div class="selected-channels">
                <div *ngIf="selectedChannels.length > 0" class="channel-tags">
                  <div *ngFor="let channel of selectedChannels" class="channel-tag">
                    {{ channel }}
                    <button class="remove-channel" (click)="toggleChannelSelection(channel)">×</button>
                  </div>
                </div>
                <div *ngIf="selectedChannels.length === 0" class="empty-state-text">
                  No channels selected
                </div>
              </div>
              
              <div class="channel-list">
                <div *ngFor="let channel of availableChannels" 
                     class="channel-option" 
                     [ngClass]="{'selected': isChannelSelected(channel)}"
                     (click)="toggleChannelSelection(channel)">
                  <span class="channel-name">{{ channel }}</span>
                  <span class="channel-check" *ngIf="isChannelSelected(channel)">✓</span>
                </div>
                <div *ngIf="availableChannels.length === 0" class="empty-state-text">
                  No channels available
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="channelsError" class="error-text">Please select at least one Slack channel.</div>
        <div *ngIf="emailsError" class="error-text">Please enter a valid email address</div>
        <div *ngIf="nameError" class="error-text">Profile name is required.</div>
        </div>

        <!-- Form Buttons -->
        <div class="form-actions">
          <button class="mab__button mab__button--secondary" (click)="closeModal()">Cancel</button>
          <button class="mab__button mab__button--primary" (click)="saveProfile()">
            {{ currentProfileIndex !== null ? 'Save Changes' : 'Create Profile' }}
          </button>
        </div>
      </div>
    </div>
  </div>